export default {"src":"/_next/static/media/our-partners-img-six.9d7128b4.svg","height":84,"width":150};